import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("最大行数")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("按表格")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("按表单")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_tip = _resolveComponent("tip")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form_item, { label: "提示文字" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: _ctx._placeholder,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx._placeholder) = $event)),
          size: "default",
          placeholder: "提醒添加记录的提示"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_form_item, { label: "最大行数" }, {
      label: _withCtx(() => [
        _createVNode(_component_tip, { content: "允许添加多少条记录（为0则不限制）" }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input_number, {
          modelValue: _ctx._value.maxSize,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx._value.maxSize) = $event)),
          "controls-position": "right",
          precision: 0,
          max: 100,
          min: 0,
          size: "default",
          placeholder: "限制条数"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_form_item, { label: "布局方式" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_radio, {
          modelValue: _ctx._value.rowLayout,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx._value.rowLayout) = $event)),
          name: "layout",
          label: true
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_radio, {
          modelValue: _ctx._value.rowLayout,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx._value.rowLayout) = $event)),
          name: "layout",
          label: false
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_form_item, { label: "展示合计" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_switch, {
          modelValue: _ctx._value.showSummary,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx._value.showSummary) = $event))
        }, null, 8, ["modelValue"]),
        (_ctx._value.showSummary)
          ? (_openBlock(), _createBlock(_component_el_select, {
              key: 0,
              "value-key": "column.title",
              modelValue: _ctx._value.summaryColumns,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx._value.summaryColumns) = $event)),
              style: {"width":"100%"},
              size: "default",
              multiple: "",
              clearable: "",
              placeholder: "请选择合计项"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: column.id,
                    label: column.title,
                    value: column.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_el_form_item, { label: "展示边框" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_switch, {
          modelValue: _ctx._value.showBorder,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx._value.showBorder) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}